import { useEffect } from "react";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import { getPrimaryDomain } from "@/react/helpers/urlHelpers/currentDomain";

export function useSetLocaleCookieFromParams() {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const locale = params.get("locale");

    if (locale) {
      Cookies.set("locale", locale, {
        expires: 1,
        path: "/",
        domain: "." + getPrimaryDomain(window.location.hostname),
      });
    }
  }, [search]);
}
